import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';

const PricingProctorCollected = observer(class PricingProctorCollected extends React.Component {
  render() {
    const { fees, translation } = this.props;
    const userTotal = currencyFormatter.format(fees.userTotal, {code: fees.currencyCode});

    if(fees) {
      return (
        <div>
          <h2 className="panel__title">{translation.title}</h2>

          <p>
            {translation.body.replace('%fees%', userTotal)}
          </p>

          <span></span>
        </div>
      )
    }

    return null;
  }
})

export default translate('PricingProctorCollected')(PricingProctorCollected);


// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/PricingProctorCollected.js